import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import decode from 'jwt-decode';
import 'rxjs/add/operator/map'

import { AuthenticationService } from '../AuthService/auth.service'

@Injectable()
export class RoleGuard implements CanActivate {

  constructor(public auth: AuthenticationService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot) {

    const expectedRole = route.data.expectedRole;

    const user1 = localStorage.getItem('User')
    console.log(user1)

    var temp = JSON.parse(user1)

    const token = temp['token'];
    console.log(token)

    const tokenPayload = decode(token);
    console.log(tokenPayload)
    console.log(tokenPayload.message);
    console.log(tokenPayload.user.role);

    var str = tokenPayload.user.role.toLowerCase()

    console.log(str,'  Role')
    if (str!= expectedRole) {
      this.router.navigate(['login']);
      return false;
      
    }
    return true;
  }

}


// WEBPACK FOOTER //
// ./src/app/login/AuthGuard/role.guard.ts